import React from 'react';
import {useShallow} from 'zustand/react/shallow';
import FeatureFlag from 'client/components/FeatureFlag/FeatureFlag.react';

import FreeEntryInputArea from '../FreeEntryInputArea.react';
import {
  useQuestionTranslationStore,
  NoTranslationWarningHeader,
  answerInEnglishText
} from '../../shared/TranslationSection';
import {QuestionComponentProps} from '../../shared/QuestionComponent/QuestionComponent.react';

const FreeEntryInputWrapper = (props: QuestionComponentProps) => {
  const {showAnswerTranslation} = useQuestionTranslationStore(
    useShallow((state) => ({
      showAnswerTranslation: state.toggleStatus.answer
    }))
  );

  return (
    <FeatureFlag name='assignment_question_translations'>
      <FreeEntryInputArea
        {...props}
        showTranslations={showAnswerTranslation}
        translationWarning={<NoTranslationWarningHeader text={answerInEnglishText} />}
      />
      <FeatureFlag.Fallback>
        <FreeEntryInputArea {...props} />
      </FeatureFlag.Fallback>
    </FeatureFlag>
  );
};

export default FreeEntryInputWrapper;
